import { render, staticRenderFns } from "./LinkTag.vue?vue&type=template&id=4ea72270"
import script from "./LinkTag.vue?vue&type=script&lang=js"
export * from "./LinkTag.vue?vue&type=script&lang=js"
import style0 from "./LinkTag.vue?vue&type=style&index=0&id=4ea72270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports